module.exports = __webpack_public_path__ + "img/online2.a378b0da.svg";